import { render, staticRenderFns } from "./CustomerAddForm.vue?vue&type=template&id=30f9995e&scoped=true&"
import script from "./CustomerAddForm.vue?vue&type=script&lang=js&"
export * from "./CustomerAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f9995e",
  null
  
)

export default component.exports